import $ from 'jquery';
window.$ = window.jQuery = $;
// Foundation 6 calls .sort() on jQuery collections; jQuery 4 removed it.
$.fn.sort = [].sort;
import './foundation.js';
import { UAParser } from 'ua-parser-js';
import './ajaxDefaults.js';
import * as Plugins from './plugins.js';
window.MyAngelcam = { ...Plugins };
window.UAParser = UAParser;
